import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/regency-anantam-Logo.webp"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Regency Group is a trusted real estate developer, known for quality
        construction, timely delivery and premium residential projects. With a
        strong presence in Mumbai, Thane, Navi Mumbai and Kalyan-Dombivli, the
        group has delivered several landmark projects that redefine modern
        living. Regency Anantam NXT continues their legacy of excellence,
        offering homebuyers a perfect blend of luxury, convenience and
        affordability.
      </p>

      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51700055848.webp" alt="rera qr" />
          <strong>P51700055848</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
